module.exports = "/legacy/d78057d8717ab70666029da6f975cacd.png";